import React from 'react';
import styled from 'astroturf/react';
import { Heading } from 'js/design_system/Heading';
import { Body } from 'js/design_system/Body';
import { CiterightInfoBanner } from './CiterightInfoBanner';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: var(--spacing-md-48) var(--spacing-sm-24);
`;

interface CiterightLandingLayoutProps {
  heading?: string;
  subtitle: string;
  infoBannerTitle?: string;
  infoBannerDescription: string;
  infoBannerFeatures?: string[];
  children: React.ReactNode;
}

export const CiterightLandingLayout: React.FC<CiterightLandingLayoutProps> = ({
  heading = 'CiteRight',
  subtitle,
  infoBannerTitle,
  infoBannerDescription,
  infoBannerFeatures,
  children,
}) => {
  return (
    <Container>
      <Heading
        size="xl"
        as="h1"
        style={{ marginBottom: 'var(--spacing-xs-16)' }}
      >
        {heading}
      </Heading>
      <Body
        size="lg"
        style={{
          marginBottom: 'var(--spacing-sm-32)',
          color: 'var(--brand-colors-neutral-800)',
        }}
      >
        {subtitle}
      </Body>

      <CiterightInfoBanner
        title={infoBannerTitle}
        description={infoBannerDescription}
        features={infoBannerFeatures}
      />

      {children}
    </Container>
  );
};
